import React from "react";
import { Redirect } from "react-router-dom";

/** Build a route component that 302s client-side to `to`. */
export function redirectTo(to) {
  return function RedirectRoute() {
    return <Redirect to={to} />;
  };
}
